// extracted by mini-css-extract-plugin
export default {"container":"BUSINESS_DETAILS_container__wKQqQ","card":"BUSINESS_DETAILS_card__r-5hA"};